import React from 'react';
import PropTypes from 'prop-types';

import {longStandardDate} from 'utils/translate/date_formatter';

const LongStandardDateText = (props) => {
  const {date} = props;
  return (
    <>
      {longStandardDate(new Date(date))}
    </>
  );
};
LongStandardDateText.propTypes = {
  date: PropTypes.any.isRequired,
};

export default React.memo(LongStandardDateText);
